
define('ldsh!common/templates/checking_urls_error', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="flexbox align-space-between">\n    <span class="ri-close-circle-line"></span>\n    <div class="ml20 f20" style="flex-grow: 1;">\n        ';
 if (message.maxUrlAllowed) { ;
__p += '             \n            <p class="i18n" data-i18n="alertView.checkingURLsError.maxUrlAllowed"\n               data-i18n-options=\'{"maxUrlAllowed":"' +
__e( message.maxUrlAllowed ) +
'", "numUrls":"' +
__e( message.urls ) +
'"}\'>               \n            </p>\n        ';
 } else {  ;
__p += '\n            <p class="i18n" data-i18n="alertView.checkingURLsError.title"></p>\n            <p class="i18n" data-i18n="alertView.checkingURLsError.description"></p>\n\n            <div class="mt15">\n                <button\n                    class="ed-btn ed-btn-small ed-show-description i18n"\n                    data-i18n="alertView.checkingURLsError.viewURLs"\n                ></button>\n            </div>\n\n            <ul class="ed-alert-description" style="display: none">\n                ';
 _.each(message, function(link) { ;
__p += '\n                <li>' +
__e( link ) +
'</li>\n                ';
 }) ;
__p += '\n            </ul>\n        ';
 } ;
__p += '\n        <div class="mt45">\n            <button\n                class="ed-btn ed-btn-small ed-close-alert ed-btn-secondary-flat i18n"\n                data-i18n="alertView.checkingURLsError.actionButton"\n            ></button>\n        </div>\n    </div>\n</div>\n';

}
return __p
};});

